import { EndpointReponseProps } from "../../types";

// export const baseURL = "http://localhost:8080";
export const baseURL = process.env.REACT_APP_BASE_URL;

export const Endpoints = {
  Login: (): EndpointReponseProps => ({
    route: `${baseURL}/auth/login`,
    method: "POST",
  }),
  GetProfile: (): EndpointReponseProps => ({
    route: `${baseURL}/auth/profile`,
    method: "GET",
  }),
  CreateSignature: (): EndpointReponseProps => ({
    route: `${baseURL}/signatures`,
    method: "POST",
  }),
  GetSignatures: (): EndpointReponseProps => ({
    route: `${baseURL}/signatures`,
    method: "GET",
  }),
  GetSignatureById: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/signatures/${id}`,
    method: "GET",
  }),
  CreateHymn: (): EndpointReponseProps => ({
    route: `${baseURL}/hymns/new`,
    method: "POST",
  }),
  GetHymns: (
    page: number,
    limit: number,
    search?: string,
  ): EndpointReponseProps => ({
    route: `${baseURL}/hymns/get?page=${page}&limit=${limit}${
      search ? `&search=${search}` : ""
    }`,
    method: "GET",
  }),

  GetHymn: (hymnId: string): EndpointReponseProps => ({
    route: `${baseURL}/hymns/${hymnId}`,
    method: "GET",
  }),
  GetUploadFile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/file/upload`,
      method: "POST",
    };
  },
  UpdateHymn: (hymnId: string): EndpointReponseProps => ({
    route: `${baseURL}/hymns/${hymnId}`,
    method: "PUT",
  }),
  GetComments: (hymnId: string): EndpointReponseProps => ({
    route: `${baseURL}/comments/${hymnId}`,
    method: "GET",
  }),
  DeleteComment: (commentId: string): EndpointReponseProps => ({
    route: `${baseURL}/comments/${commentId}`,
    method: "DELETE",
  }),
};
